import React from "react";
import { MetricCard } from "./MetricCard";
import { InfoCard } from "./InforCard";
import { capitalizeFirstLetter } from "../../../Utils/helper";
import { useTranslation } from "react-i18next";

const getRandomColor = () => {
  const tailwindColors = [
    "bg-red-500",
    "bg-blue-500",
    "bg-green-500",
    "bg-yellow-500",
    "bg-purple-500",
    "bg-pink-500",
    "bg-indigo-500",
    "bg-teal-500",
    "bg-orange-500",
    "bg-cyan-500",
  ];
  const randomIndex = Math.floor(Math.random() * tailwindColors.length);
  return tailwindColors[randomIndex];
};

const Profile = ({ performanceDetailsDataProfile }) => {
  const { t } = useTranslation();

  const summaryFields = Object.entries(
    performanceDetailsDataProfile.summary_fields || {}
  ).map(([title, content]) => ({
    title,
    content,
  }));
  return (
    <div>
      <MetricCard
        label={t("performan.profile.diners")}
        value={performanceDetailsDataProfile.total_consumers}
      />
      <MetricCard
        label={t("performan.profile.ageGroup")}
        value={performanceDetailsDataProfile.age_stats}
      />

      <section className="p-3 mb-3 bg-white rounded-lg border border-solid border-stone-200 max-sm:mb-2">
        <h2 className="mb-3 text-lg font-bold text-neutral-500">
          {t("performan.profile.gender")}
        </h2>
        {(performanceDetailsDataProfile.gender_stats || []).map(
          ({ gender, percentage, color }) => {
            // Use the provided color, or generate a random color
            const genderColor = color || getRandomColor();

            return (
              <div
                key={gender}
                className="flex flex-row items-center mb-3 gap-2 "
              >
                <span className="text-sm text-neutral-500 w-[75px] max-sm:mb-1 ">
                  {capitalizeFirstLetter(gender)}
                </span>
                <span
                  className={`items-center p-1 text-sm font-medium  text-white ${genderColor} rounded-md `}
                >
                  {percentage}
                </span>
                <div className="flex-1 h-2 rounded-2xl bg-stone-200 max-sm:mt-1">
                  <div
                    className={`h-2 rounded-2xl ${genderColor}`}
                    style={{ width: `${percentage}%` }}
                    role="progressbar"
                    aria-valuenow={percentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
            );
          }
        )}
      </section>

      {summaryFields.map((card, index) => (
        <InfoCard key={index} title={card.title} content={card.content} />
      ))}
    </div>
  );
};

export default Profile;
